import { useEffect } from 'react';
// @ts-ignore
import { KrpanoPlayer } from 'pano-sdk';
import { useGate, useStore, useStoreMap } from 'effector-react';
import type { KrpPlayer, SceneData } from '@types';
import { $tourData } from '@stores/dataStores';
import { useCompareItemQuery } from '../utils';
import {
  $GateCompareItemData,
  $compareSelected,
  $compareState,
  $compareStateApi,
  $showCompareLockButton,
  $showCompareWidget,
  $showEmptyTip,
  ComparePlayer,
} from '../compareStores';
import { CompareModeTabbar } from './CompareModeTabbar';
import { COMPARE_DIV_ID } from '../constants';
import { LockButton } from './LockButton';
import { ModeHorizontalWidgets } from './ModeHorizontalWidgets';
import { ModeVerticalWidgets } from './ModeVerticalWidgets';
import { ModeSplitWidgets } from './ModeSplitWidgets';
import { ModeOverlapWidgets } from './ModeOverlapWidgets';
import { EmptyTip } from './EmptyTip';

interface Props {
  loadedScene: SceneData;
}

export function PlayerContainer({ loadedScene }: Props) {
  const selected = useStore($compareSelected);
  const list = loadedScene.compareConfig?.scenes ?? [];
  const hideModeTabbar = loadedScene.compareConfig?.showModeOption === 0;
  const compareItem = list.find((x) => x.id === selected) ?? null;
  const { data: comparingData } = useCompareItemQuery(compareItem);
  const showWidget = useStore($showCompareWidget);
  const showLockButton = useStore($showCompareLockButton);
  const showEmptyTip = useStore($showEmptyTip);

  const { mode } = useStore($compareState);

  useGate(
    $GateCompareItemData,
    comparingData
      ? { ...comparingData, viewOffset: compareItem?.viewOffset }
      : null
  );

  const dragMode = useStoreMap({
    store: $tourData,
    fn: (state) => state.flag?.dragMode ?? 1,
    keys: [],
  });
  const canvasBgColor = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.config?.ui?.canvasBgColor || '#000000',
  });

  useEffect(() => {
    /** 等待数据请求完成 */
    const player = new KrpanoPlayer() as KrpPlayer;
    player.createPlayer(
      COMPARE_DIV_ID,
      {},
      () => {
        player.controlMode({ mouse: dragMode ? 'drag' : 'moveto' });
        ComparePlayer.register(player);
        ComparePlayer.init();
      },
      {
        backgroundColor: canvasBgColor,
      }
    );

    return () => {
      ComparePlayer.remove();
      $compareStateApi.reset();
    };
  }, []);

  return (
    <>
      <div className="absolute inset-0" id={COMPARE_DIV_ID} />
      {showWidget && (
        <>
          {mode === 'horizontal' && <ModeHorizontalWidgets />}
          {mode === 'vertical' && <ModeVerticalWidgets />}
          {mode === 'split' && <ModeSplitWidgets />}
          {mode === 'overlap' && <ModeOverlapWidgets />}
          {showLockButton && <LockButton />}
          {!hideModeTabbar && <CompareModeTabbar />}
        </>
      )}
      {showEmptyTip && <EmptyTip mode={mode} />}
    </>
  );
}
